export default "__VITE_ASSET__Dv0a67yB__"